import { gql } from '__generated__/gql';

export const GET_ACTIVITY_ASSIGNMENT = gql(/* GraphQL */ `
  query getActivityAssignment($id: Int!) {
    activityAssignment(id: $id) {
      id
      state
      actualTimeToComplete
      completedDate
      campaign {
        id
        name
      }
      store {
        id
        name
      }
      isAssignedByStore
      assignedUser {
        id
        firstName
        lastName
      }
      steps {
        id
        step {
          id
          subject
          description
          startDate
          dueDate
          estimatedTimeToComplete
          actualTimeToComplete
          completedDate
          requiresReview
          isRequired
          sortOrder
          activity {
            id
          }
          question {
            id
            questionDetail
            type
            isMultiple
            questionChoices {
              id
              label
              value
              pillarScore
              sortOrder
            }
          }
          assignedUser {
            id
            firstName
            lastName
          }
        }
        response {
          id
          actualTimeToComplete
          completedDate
          textAnswer
          assignedUser {
            id
            firstName
            lastName
          }
          completedByUser {
            id
            firstName
            lastName
          }
          answers {
            id
            question {
              id
            }
            selectedChoice {
              id
              label
              value
              pillarScore
            }
            supplementalTextAnswer
          }
        }
      }
      activity {
        id
        subject
        description
        startDate
        dueDate
        estimatedTimeToComplete
        tags {
          id
          name
          displayColour
        }
        assignedUsers {
          id
          firstName
          lastName
        }
        ccRecipients {
          id
          firstName
          lastName
        }
      }
    }
  }
`);
